import { Injectable, inject } from '@angular/core';
import { AssignmentProcessService, SetProcessExecutionHoldResponse } from '@6grain/masofa-monolith-api-client/common';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/** Response of POST /assignments/processes/{processKey}/suspend and /resume. */
export interface ProcessExecutionHoldDto {
  processKey: string;
  executionSuspended: boolean;
  runningStopRequested: number;
  runningStopChanged: number;
}

/** Stops and resumes execution of one process. */
@Injectable({ providedIn: 'root' })
export class ProcessExecutionHoldService {
  private readonly api = inject(AssignmentProcessService);

  suspend(processKey: string): Observable<ProcessExecutionHoldDto> {
    return this.api.assignmentsProcessesProcessKeySuspendPost(processKey).pipe(map(normalizeHold));
  }

  resume(processKey: string): Observable<ProcessExecutionHoldDto> {
    return this.api.assignmentsProcessesProcessKeyResumePost(processKey).pipe(map(normalizeHold));
  }
}

function normalizeHold(row: SetProcessExecutionHoldResponse): ProcessExecutionHoldDto {
  return {
    processKey: row.processKey ?? '',
    executionSuspended: row.executionSuspended ?? false,
    runningStopRequested: row.runningStopRequested ?? 0,
    runningStopChanged: row.runningStopChanged ?? 0,
  };
}
